import { Component, Input, OnDestroy } from '@angular/core'

@Component({
    selector: 'mg-ui-timedloader',
    templateUrl: './ui-timedloader.component.html',
    styleUrls: ['./ui-timedloader.component.scss'],
})
export class UiTimedloaderComponent implements OnDestroy {
    @Input()
    timeoutShow: number = 2000

    @Input()
    timeoutHide: number = 100

    loaderVisible: boolean = false

    private loadingTimer: number

    private _loading: boolean = false

    get loading(): boolean {
        return this._loading
    }

    @Input()
    set loading(value: boolean) {
        clearTimeout(this.loadingTimer)
        this.loadingTimer = +setTimeout(this.syncTimer.bind(this, value), value ? this.timeoutShow : this.timeoutHide)
        this._loading = value
    }

    syncTimer(value) {
        this.loaderVisible = value
    }

    ngOnDestroy() {
        clearTimeout(this.loadingTimer)
    }
}
